import { createInertiaApp } from "@inertiajs/react";
import { createElement, ReactNode } from "react";
import { createRoot } from "react-dom/client";
import DeskLayout from "../layouts/DeskLayout";
import GuestLayout from "../layouts/GuestLayout";

// Temporary type definition, until @inertiajs/react provides one
type ResolvedComponent = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  default: any;
  layout?: (page: ReactNode) => ReactNode;
};

createInertiaApp({
  // Set default page title
  // see https://inertia-rails.dev/guide/title-and-meta
  //
  // title: title => title ? `${title} - App` : 'App',

  // Disable progress bar
  //
  // see https://inertia-rails.dev/guide/progress-indicators
  // progress: false,

  resolve: (name) => {
    const pages = import.meta.glob<ResolvedComponent>("../pages/**/*.tsx", {
      eager: true,
    });
    const page = pages[`../pages/${name}.tsx`];
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.tsx'`);
    }

    // Apply DeskLayout to all Desk pages
    if (name.startsWith("Desk/") && page?.default) {
      page.default.layout ||= (page: ReactNode) => createElement(DeskLayout, null, page);
    }

    // Apply GuestLayout to all Auth pages
    if (name.startsWith("Auth/") && page?.default) {
      page.default.layout ||= (page: ReactNode) => createElement(GuestLayout, null, page);
    }

    return page;
  },

  setup({ el, App, props }) {
    if (el) {
      createRoot(el).render(createElement(App, props));
    } else {
      console.error(
        "Missing root element.\n\n" +
          "If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n" +
          'Consider moving <%= vite_typescript_tag "inertia" %> to the Inertia-specific layout instead.'
      );
    }
  },
});
